import { InputControl } from '@/components/controls/input-control';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Dispatch, SetStateAction, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface CertificateNumberProps {
  openDalolatDialog: boolean;
  setOpenDalolatDialog: Dispatch<SetStateAction<boolean>>;
  handleConfirmDalolatnoma: () => void;
}

export const CertificateNumber = ({
  openDalolatDialog,
  setOpenDalolatDialog,
  handleConfirmDalolatnoma,
}: CertificateNumberProps) => {
  const form = useFormContext();
  const { t } = useTranslation();
  const [isNumberVisible, setIsNumberVisible] = useState(false);

  const analysisDocNumber = useWatch({
    control: form.control,
    name: 'analysis_doc_number',
  });

  return (
    <Dialog open={openDalolatDialog} onOpenChange={setOpenDalolatDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('enter.act.number')}</DialogTitle>
        </DialogHeader>
        {!isNumberVisible ? (
          <>
            <h2>
              Qabul qilinayotgan paxtaning sanoat navini bir pogʼona pastga
              tushirishga rozimisiz
            </h2>
            <DialogFooter className="flex gap-2">
              <Button
                variant="outline"
                onClick={() => setOpenDalolatDialog(false)}
              >
                {t('no')}
              </Button>
              <Button onClick={() => setIsNumberVisible(true)}>
                {t('yes')}
              </Button>
            </DialogFooter>
          </>
        ) : (
          <>
            <InputControl
              control={form.control}
              name="analysis_doc_number"
              label={t('enter.act.number')}
              isNumber
            />
            <DialogFooter className="flex gap-2">
              <Button
                variant="outline"
                onClick={() => setOpenDalolatDialog(false)}
              >
                {t('cancel')}
              </Button>
              <Button
                onClick={handleConfirmDalolatnoma}
                disabled={!analysisDocNumber}
              >
                {t('confirm')}
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
